
import {useEffect, useState } from 'react';
import { Volume2, Monitor, ShoppingCart, Package, Activity, Layers, Youtube
} from 'lucide-react';
import configData from "../config.json";
import { getToken } from "../utils/auth";
import { TakeOverScreen } from "../functions/takeoverscreen";
import { SetCastInterruptUrl } from "../functions/SetCastInterruptUrl";

export function Step3Deploy ({
  FadeIn,
  allGenratedBanners,
  allGenratedVideos,
  bannerUrl,
  videoUrl,
  allUploadedAudios,
  audioUrl,
  uploadBannerID,
  uploadAudioID,
  uploadVideoID,
  setScreenData,
  screens,
  setScreens,
  notify,

}) {

    const [processingRow, setProcessingRow] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    const [selectedScreens, setSelectedScreens] = useState({});
    const [deploymentStatus, setDeploymentStatus] = useState({}); // 'success', 'failed', or undefined 

    const fetchScreens = async () => {
      try {
      const token = getToken()
      // return
      const res = await fetch(`${configData.DEMO_URL}/Screens`, {
          method: "GET",
          headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
          },
      });
      if (!res.ok) {
        // handle 404 separately
        if (res.status === 404) {
          let errorMessage = res?.message || 'No Screens Found';
          try {
            const errorBody = await res.json();
            if (errorBody?.message) {
              errorMessage = errorBody.message;
            }
          } catch (_) {}
          notify(errorMessage, "error");
          return false;
        }

        throw new Error(`Failed To Fetch Screens From Media Management`);
      }
      const data = await res.json();

      setScreens(data["screens"]);
      return
      } catch (error) {
        if (error.message) {
          notify(error.message, "error");
        } else {
          notify("Failed To Fetch Screens From Media Management", "error");
        }
        
        return false;
      }
  };

    useEffect(() => {
      if (screens.length <= 0){
        fetchScreens()
      }
    }, []);
  
  
  const handleQueue = async (idx, item) => {
    if (!isRowReady(idx)) return;

    setProcessingRow(idx);

    try {
      // Use custom deploy function if provided, otherwise use default TakeOverScreen
      const deployFunction = item.deployFunction || TakeOverScreen;
      const success = await deployFunction(item, idx, notify, configData, getToken, setScreenData, selectedScreens);
      setDeploymentStatus(prev => ({
        ...prev,
        [idx]: success ? 'success' : 'failed'
      }));
    } finally {
      setProcessingRow(null);
    }
  };

    const toggleRow = (idx) => {
      setExpandedRow(prev => (prev === idx ? null : idx));
    };

    const toggleScreen = (rowIdx, screenId) => {
      setSelectedScreens(prev => {
        const rowScreens = new Set(prev[rowIdx] || []);
        
        rowScreens.has(screenId)
          ? rowScreens.delete(screenId)
          : rowScreens.add(screenId);

        // Reset deployment status when selection changes
        setDeploymentStatus(prevStatus => {
          const newStatus = { ...prevStatus };
          delete newStatus[rowIdx];
          return newStatus;
        });

        return {
          ...prev,
          [rowIdx]: rowScreens
        };
      });
    };

    const isRowReady = (idx) =>
      selectedScreens[idx] && selectedScreens[idx].size > 0;
    const getMediaUrl = (media) => media?.url || media?.videoUrl || media?.video_url || "";
    const bannerItem = allGenratedBanners.find(banner => banner.url === bannerUrl);
    const videoItem = allGenratedVideos.find(video => getMediaUrl(video) === videoUrl);
    const audioItem = allUploadedAudios.find(audio => audio.url === audioUrl);
    const items = [
      { name: "Video Screens", status: "Ready", color: "green", icon: Youtube, value: videoItem || uploadVideoID, deployFunction: TakeOverScreen, screens: [...screens,{ id: null, name: "Cast" }] },
      { name: "Digital Screens", status: "Ready", color: "green", icon: Monitor, value: bannerItem, deployFunction: TakeOverScreen, screens: [...screens,{ id: null, name: "Cast" }]},
      { name: "Audio Systems", status: "Ready", color: "green", icon: Volume2, value: audioItem, deployFunction: TakeOverScreen, screens: [...screens,{ id: null, name: "Cast" }] },
      { name: "Smart Carts", status: "Ready", color: "green", icon: ShoppingCart, value: null, deployFunction: console.log, screens: [] },
      { name: "Instant Banner", status: "Ready", color: "green", icon: Activity, value: bannerItem, deployFunction: SetCastInterruptUrl, screens: [ { id: null, name: "Cast" } ] },
      { name: "Instant Video", status: "Ready", color: "green", icon: Layers, value: videoItem || uploadVideoID, deployFunction: SetCastInterruptUrl, screens: [ { id: null, name: "Cast" } ] },
      { name: "Scan&Go", status: "Ready", color: "green", icon: Package, value: null, deployFunction: console.log, screens: []},
    ];
    
  return (
    <FadeIn className="p-8 md:p-16 flex flex-col items-center justify-center   bg-white">
      <div className="max-w-2xl w-full text-center">
        <h3 className="text-2xl font-bold text-blue-900 mb-2">Ready to Deploy?</h3>
        <p className="text-blue-700 mb-8">Push assets to 14 connected store locations.</p>
        
        <div className="bg-blue-50 rounded-xl shadow-sm border border-blue-200 overflow-hidden mb-8 text-left">
          <div className="flex items-center justify-between p-4 border-b border-blue-200 bg-blue-100">
            <span className="font-bold text-blue-800 text-sm">Deployment Status</span>
            <span className="text-xs text-blue-600">Last check: Just now</span>
          </div>
          <div className="p-4 space-y-3">
            {items.map((item, idx) => {
              const isExpanded = expandedRow === idx;
              const ready = isRowReady(idx);

              return (
                <div key={idx} className="border rounded-lg p-3 bg-white">
                  
                  {/* Row header */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() => toggleRow(idx)}
                        className="text-blue-600 font-bold text-lg w-6"
                      >
                        {isExpanded ? "−" : "+"}
                      </button>

                      <item.icon size={16} className="text-blue-400" />
                      <span className="text-sm font-medium text-blue-900">
                        {item.name}
                      </span>
                    </div>

                    <button
                      type="button"
                      disabled={!isRowReady(idx) || processingRow === idx}
                      className={`text-xs border px-2 py-1 rounded flex items-center gap-2 ${
                        processingRow === idx
                          ? "bg-gray-200 text-gray-500 border-gray-300 cursor-wait"
                          : deploymentStatus[idx] === 'success'
                            ? "bg-green-100 text-green-800 border-green-200"
                            : deploymentStatus[idx] === 'failed'
                              ? "bg-red-100 text-red-800 border-red-200"
                              : isRowReady(idx)
                                ? "bg-orange-100 text-orange-800 border-orange-200"
                                : "bg-blue-100 text-blue-800 border-blue-200"
                      }`}
                      onClick={() => handleQueue(idx, item)}
                    >
                      {processingRow === idx ? (
                        <>
                          <span className="animate-spin">⏳</span>
                          Processing…
                        </>
                      ) : isRowReady(idx) ? (
                        `${selectedScreens[idx].size} Selected – Deploy`
                      ) : (
                        "Deploy"
                      )}
                    </button>
                  </div>

                  {/* Expanded screen list */}
                  {isExpanded && (
                    <div className="mt-3 pl-8 space-y-2">
                      {item.screens.map(screen => (
                        <label
                          key={screen.id}
                          className="flex items-center gap-2 text-sm text-blue-900 cursor-pointer"
                        >
                          <input
                            type="checkbox"
                            checked={selectedScreens[idx]?.has(screen.id) || false}
                            onChange={() => toggleScreen(idx, screen.id)}
                          />
                          {screen.name}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <button className="bg-blue-600 hover:bg-blue-500 text-white text-lg font-bold py-4 px-12 rounded-full shadow-lg transition-transform hover:scale-105 active:scale-95 flex items-center gap-2 mx-auto"
        onClick={() => {
          window.open("https://agent.catch-retail.ai/login", "_blank");
        }}
        >
          🚀 Deploy Campaign
        </button>
      </div>
    </FadeIn>
  );
};